import { render } from "./Pallisers.vue?vue&type=template&id=20b216cc&scoped=true"
import script from "./Pallisers.vue?vue&type=script&lang=js"
export * from "./Pallisers.vue?vue&type=script&lang=js"

import "./Pallisers.vue?vue&type=style&index=0&id=20b216cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20b216cc"

export default script